import qs from 'qs';

/**
 * V1: Helper to generate url for similar items request
 * @param {number} Id mandatory, id of item to find similar to
 * @param {number} pageSize mandatory, limit items fetched
 */
const similarItemsRequestBuilder = (id, pageSize) => {
    const endpoint = '/ma/recommendations-similar-items';

    return () => {
        let queryParameters = {
            id,
            pageSize
        };

        return `${endpoint}?${qs.stringify(queryParameters)}`;
    };
};

/**
 * V1: Helper to generate url for similar items request
 * @param {number} Id mandatory, id of item to find similar to
 * @param {number} pageSize mandatory, limit items fetched
 */
const similarItemsFromShopRequestBuilder = (id, pageSize) => {
    const endpoint = '/ma/recommendations-similar-items-from-shop';

    return () => {
        let queryParameters = {
            id,
            pageSize
        };

        return `${endpoint}?${qs.stringify(queryParameters)}`;
    };
};
export { similarItemsRequestBuilder, similarItemsFromShopRequestBuilder };



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/recommendations/similar-items-request.js